export const styles = theme => ({
  screen: {
    background: theme.palette.background.paper,
    display: "flex",
    height: "100vh"
  },
  card: {
    display: "flex",
    boxShadow: "2px 2px 2px 1px #ccc",
    minWidth: "300px",
    justifyContent: "center",
    alignSelf: "center",
    margin: "2rem 3rem 2rem 3rem"
  },
  content: {
    margin: "70px 0 0 0",
    // background: '#FFFFFF',
    height: "100%",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Montserrat, sans-serif",
    // padding: "5rem 2rem",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      padding: "4rem 2rem"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "2rem 4rem 0rem 4rem"
    },
    [theme.breakpoints.up("md")]: {
      padding: "1rem 15rem"
    }
  },
  top: {
    flex: 0.1,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 0rem 0 0rem"
    },
    [theme.breakpoints.up("md")]: {
      padding: "5rem 5rem 0 5rem"
    }
  },
  logo: {
    width: "100%"
  },
  subheader: {
    textAlign: "center",
    marginTop: "10px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem"
    }
  },
  middle: {
    display: "flex",
    flexDirection: "column",
    flex: 0.6,
    justifyContent: "center",
    padding: "0rem 0",
    [theme.breakpoints.up("md")]: {
      padding: "0rem 5rem 5rem 5rem"
    }
  },
  bottom: {
    display: "flex",
    flexDirection: "column",
    flex: 0.2,
    paddingTop: 20,
    minHeight: 100,
    [theme.breakpoints.up("md")]: {
      padding: "0rem 15rem",
      minHeight: 0
    }
  }
});
